import { render, staticRenderFns } from "./MandateTermination.vue?vue&type=template&id=619d73f6&scoped=true&"
import script from "./MandateTermination.vue?vue&type=script&lang=js&"
export * from "./MandateTermination.vue?vue&type=script&lang=js&"
import style0 from "./MandateTermination.vue?vue&type=style&index=0&id=619d73f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d73f6",
  null
  
)

export default component.exports